/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationCache, QueryCache, QueryClient, UseMutationOptions } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { getAxiosError } from "./axios";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (isAxiosError(error)) {
        // console.log(getAxiosError(error));
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (isAxiosError(error)) {
        // console.log(getAxiosError(error));
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
});

export default queryClient;

export type ApiFnReturnType<FnType extends (...args: any) => Promise<any>> = Awaited<ReturnType<FnType>>;
export type QueryConfig<T extends (...args: any[]) => any> = Omit<ReturnType<T>, "queryKey" | "queryFn">;

export type MutationConfig<MutationFnType extends (...args: any) => Promise<any>> = UseMutationOptions<
  ApiFnReturnType<MutationFnType>,
  Error,
  Parameters<MutationFnType>[0]
>;

export const persister = createSyncStoragePersister({
  storage: window.localStorage,
});
